import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=c836b4ac&scoped=true&"
var script = {}
import style0 from "./top-bar.vue?vue&type=style&index=0&id=c836b4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c836b4ac",
  null
  
)

export default component.exports